<template>
    <div ref="recaptchaContainer"></div>
</template>

<script>
    import { Constants } from "../functions/constants";

    export default {
        name: "Recaptcha",
        props: {
            sitekey: {
                type: String,
                default: ''
            },
            size: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
            theme: {
                type: String,
                default: 'light'
            },
            tabindex: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                widgetId: null
            }
        },
        methods: {
            grecaptchaLoadedHandler(obj, eventArgs) {
                var that = this;
                if (!eventArgs)
                    return;

                var src = eventArgs.src;
                if (src !== Constants.EXTERNAL_SCRIPTS.GRECAPTCHA_SRC)
                    return;

                var grecaptcha = window.grecaptcha;
                if (!grecaptcha) {
                    console.error('[recaptcha] window.grecaptcha is not defined');
                    return false;
                }

                grecaptcha.ready(function () {
                    that.init(grecaptcha);
                });
            },
            init(grecaptcha) {
                const recaptchaOptions = {
                    sitekey: this.sitekey,
                    theme: this.theme,
                    callback: this.grecaptchaConfirmed,
                    'expired-callback': this.grecaptchaExpired
                }

                if (this.type)
                    recaptchaOptions['type'] = this.type;

                if (this.size)
                    recaptchaOptions['size'] = this.size;

                if (this.tabindex)
                    recaptchaOptions['tabindex'] = this.tabindex;

                let recaptchaContainer = this.$refs.recaptchaContainer;
                this.widgetId = grecaptcha.render(recaptchaContainer, recaptchaOptions)
            },
            grecaptchaConfirmed(response) {
                this.$emit('input', response)
            },
            grecaptchaExpired() {
                this.grecaptchaReset()
            },
            grecaptchaReset() {
                if (window.grecaptcha) {
                    window.grecaptcha.reset(this.widgetId)
                    this.$emit('input', '')
                }               
            }
        },

        created() {
            GlobalApp.EventHub.subscribeToEvent(Constants.EVENTS.EXTERNAL_SCRIPT_LOADED, this.grecaptchaLoadedHandler);

            this.sitekey = this.sitekey || GlobalApp.generalSettings.gRecaptchaDataSitekey;
            if (!this.sitekey) {
                console.error('[recaptcha] Sitekey is not defined')
                return false
            }

            GlobalApp.ExternalScriptsLoader.load(Constants.EXTERNAL_SCRIPTS.GRECAPTCHA_SRC);
        },

        destroyed() {
            GlobalApp.EventHub.unsubscribeToEvent(Constants.EVENTS.EXTERNAL_SCRIPT_LOADED, this.grecaptchaLoadedHandler);
        }
    };
</script>